import React from "react";
import Sync from "@mui/icons-material/Sync";

const SpinIcon = () => {
  return <Sync className="spinner" />;
};

export default SpinIcon;
